<template>
  <div class="ui container fluid">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    title: String,
    titleClass: String,
    iconClass: String,
  },
};

</script>
